module.exports = __webpack_public_path__ + "img/9788936456023.f21f7ad3.jpg";